import {
  OfferSortBy,
  OfferSortByDirection,
} from '@lambda/apis/src/catalog-v2/types';

export const DEFAULT_SORT_BY = OfferSortBy.SALES;
export const DEFAULT_SORT_BY_DIRECTION = OfferSortByDirection.DESC;

export const DEALS_EXCLUDED_CATEGORIES = ['Accessories & Bundles'];

export const SORT_BY_OPTIONS = [
  {
    label: 'Best Selling',
    sortBy: OfferSortBy.SALES,
    sortDirection: OfferSortByDirection.DESC,
  },
  {
    label: 'Latest Release',
    sortBy: OfferSortBy.RELEASE_DATE,
    sortDirection: OfferSortByDirection.DESC,
  },
  {
    label: 'Price (High to Low)',
    sortBy: OfferSortBy.PRICE,
    sortDirection: OfferSortByDirection.DESC,
  },
  {
    label: 'Price (Low to High)',
    sortBy: OfferSortBy.PRICE,
    sortDirection: OfferSortByDirection.ASC,
  },
];
